/* Breezary homepage v5: hero carousel, browse tabs, review scroller */
(function () {
  'use strict';
  var root = document.querySelector('[data-bz5]');
  if (!root || root.__bz5) return;
  root.__bz5 = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };

  /* hero: fades between slides, pauses while hovered / focused / hidden */
  var hero = root.querySelector('[data-bz5-hero]');
  if (hero) {
    var slides = hero.querySelectorAll('.bz5-slide'), dots = hero.querySelectorAll('.bz5-dot'), cur = 0, hold = false;
    var go = function (n) {
      n = (n + slides.length) % slides.length;
      slides[cur].classList.remove('is-active'); slides[cur].setAttribute('aria-hidden', 'true');
      if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].setAttribute('aria-current', 'false'); }
      cur = n;
      slides[cur].classList.add('is-active'); slides[cur].removeAttribute('aria-hidden');
      if (dots[cur]) { dots[cur].classList.add('is-active'); dots[cur].setAttribute('aria-current', 'true'); }
    };
    each(dots, function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var prev = hero.querySelector('[data-bz5-prev]'), next = hero.querySelector('[data-bz5-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    hero.addEventListener('mouseenter', function () { hold = true; });
    hero.addEventListener('mouseleave', function () { hold = false; });
    hero.addEventListener('focusin', function () { hold = true; });
    hero.addEventListener('focusout', function () { hold = false; });
    if (slides.length > 1) setInterval(function () { if (!hold && !reduce.matches && !document.hidden) go(cur + 1); }, 6500);
  }

  /* browse tabs (WAI-ARIA tabs, arrow keys move between tabs) */
  each(root.querySelectorAll('[data-bz5-tabs]'), function (box) {
    var tabs = box.querySelectorAll('[role=tab]');
    var select = function (t, focus) {
      each(tabs, function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.setAttribute('tabindex', on ? '0' : '-1');
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    };
    each(tabs, function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  });

  /* review scroller: arrow buttons move one card, and switch off at either end */
  each(root.querySelectorAll('[data-bz5-scroller]'), function (wrap) {
    var track = wrap.querySelector('[data-bz5-track]');
    var prev = wrap.querySelector('[data-bz5-prev]'), next = wrap.querySelector('[data-bz5-next]');
    if (!track) return;
    var step = function () { var c = track.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    var sync = function () {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();


